import { render, staticRenderFns } from "./select-many.vue?vue&type=template&id=7ec6d2d7&"
import script from "./select-many.component.ts?vue&type=script&lang=ts&"
export * from "./select-many.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports